<div placement="bottom" tooltip *ngIf="item.type === 'shape'" #libTileElem class="plus-create-item-container plus-create-item fx-ellipsis" draggable="false" >
    <div *ngIf="(loadThumb | async);then thumbnail else defaultImage" ></div>
    <ng-template #thumbnail>
        <div *ngIf="item.premium"  class="col-menu-item-premium">
            <div class="premium">
                <div class="icon">
                    <svg class="nu-icon">
                        <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-premium-crown"></use>
                    </svg>
                </div>
            </div>
        </div>
        <thumbnail-image
            *ngIf="item?.thumbnailType==='image' || (item?.thumbnailType==='canvas' && !item?.renderStyledThumbnail)"
            class="shape-thumbnail-image"
            [defId]="item?.data.defId"
            [version]="item?.data.version"
            [url]="item.thumbnailUrl">
        </thumbnail-image>
        <plus-thumbnail-canvas
            *ngIf="item.thumbnailType==='canvas' && item?.renderStyledThumbnail"
            class="shape-thumbnail-image"
            [defId]="item.data.defId"
            [drawCode]="item?.data.drawCode"
            [typeStyle]="item?.data.typeStyle"
            [version]="item?.data.version"
            [style]="item?.data.style"
            [focus]="focused | async"
            [canvasWidth]="canvasWidth"
            [canvasAreaWidth]="canvasAreaWidth"
            [canvasIdPrefix]="item?.canvasIdPrefix || 'thumb-search-drop'"
            >
        </plus-thumbnail-canvas>
    </ng-template>
    <div class="tooltip-content">
        <span class="tooltip-body">{{item.title}}</span>
    </div>
    <ng-template #defaultImage>
        <svg class="nu-icon light-nv-blue" >
            <use [attr.xlink:href]="iconHref" ></use>
        </svg>
    </ng-template>
</div>

<div *ngIf="item.type === 'viz'" #libTileElem class="plus-create-item-container plus-create-item" draggable="false" >
    <label class="caption">{{item.title | translate }}</label>
</div>
